import { httpFetch } from '../../Utils/httpUtils';
import commonActions from '../commonActions';

const supportLoginActions = {
    redeemSupportCode(supportCode, callback) {
        return (dispatch) => {
            dispatch(commonActions.hideAlert());

            return httpFetch(`/api/SupportCode/RedeemSupportCode/${supportCode}`, dispatch)
                .then((json) => {
                    callback(json);
                })
                .catch(() => {
                    callback();
                });
        };
    },
};

export default supportLoginActions;
